import { AddCircleOutline } from "@mui/icons-material";
import { Button } from "@mui/material";
import React, { useState } from "react";
import { T } from "../../components/T";
import CreateNewPolesetModal from "../../modals/CreateNewPolesetModal";
import { useDeviceSize } from "../../hooks/useDeviceSize";

const CreatePolesetButton = () => {
  const { xsDevice } = useDeviceSize();
  const [showCreateDialog, setShowCreateDialog] = useState(false);
  if (xsDevice) return null;

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        startIcon={<AddCircleOutline />}
        onClick={() => setShowCreateDialog(true)}
        sx={{
          marginRight: "2rem",
        }}
      >
        <T str="Create new poleset" />
      </Button>

      <CreateNewPolesetModal
        isOpen={showCreateDialog}
        close={() => setShowCreateDialog(false)}
      />
    </>
  );
};

export default CreatePolesetButton;
